import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconUpload$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconUpload extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '91fe7529763ccdaed1a5e6e223c91fc2caeb20fa', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '16ca00b915becfe96432978940e89a875c17a19e', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '77176862dee4cee3b02aee08c07fde707b541ae2', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M10.29 9H7a.41.41 0 0 1-.29-.69l4-4a.42.42 0 0 1 .57 0l4 4A.41.41 0 0 1 15 9h-3.21v5.5a.51.51 0 0 1-.5.5h-.5a.5.5 0 0 1-.5-.5zM5.5 17.5a.5.5 0 0 0-.5.5v.5a.5.5 0 0 0 .5.5h11a.5.5 0 0 0 .5-.5V18a.5.5 0 0 0-.5-.5z", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-upload", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-upload"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-upload":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconUpload$1);
            }
            break;
    } });
}

const CosmosIconUpload = CosmosIconUpload$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconUpload, defineCustomElement };
